"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActionDrawer = void 0;
var _faTimes = require("@fortawesome/free-solid-svg-icons/faTimes");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireWildcard(require("react"));
var _index = require("../index");
var _ActionDrawer = require("./ActionDrawer.styles");
var _excluded = ["className", "closeIdentifier", "children", "title", "icon", "onClose", "subTitle", "header", "topBar"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ActionDrawer = /*#__PURE__*/(0, _react.memo)(function (props) {
  var className = props.className,
    closeIdentifier = props.closeIdentifier,
    children = props.children,
    title = props.title,
    icon = props.icon,
    onClose = props.onClose,
    subTitle = props.subTitle,
    header = props.header,
    topBar = props.topBar,
    rest = _objectWithoutProperties(props, _excluded);
  var classes = (0, _ActionDrawer.useStyles)();
  var handleClose = (0, _react.useCallback)(function () {
    if (onClose) {
      onClose({}, 'backdropClick');
    }
  }, [onClose]);
  return /*#__PURE__*/_react["default"].createElement(_index.Drawer, _extends({}, rest, {
    anchor: "right",
    className: className,
    classes: {
      paper: classes.paper
    }
  }), topBar && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.topBar
  }, topBar), /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(classes.closeButton, classes.shapeButton),
    "data-test-id": closeIdentifier,
    onClick: handleClose
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _faTimes.faTimes
  })), /*#__PURE__*/_react["default"].createElement("header", {
    className: classes.header
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.headerTitle
  }, /*#__PURE__*/_react["default"].createElement("h3", {
    className: classes.title
  }, title), header && /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.extra
  }, header)), subTitle && /*#__PURE__*/_react["default"].createElement("h4", {
    className: classes.subTitle
  }, subTitle), icon && /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])(classes.icon, classes.shapeButton)
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: icon
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.content
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.holder
  }, children)));
});
exports.ActionDrawer = ActionDrawer;